module.exports = __webpack_public_path__ + "media/images/logo-e8e8d6dbeed9506807159661de1d8bd0.png";